import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { DeveloperService } from '../developer.service';
import * as developerActions from './developer.actions'

@Injectable({
    providedIn: 'root'
})

export class DeveloperEffects {
    constructor(
        private actions$: Actions,
        private developerService: DeveloperService,
        private toastr: ToastrService,
        private miscService: MiscService
    ) {}


    createPublicKey$ = createEffect(() =>
    this.actions$.pipe(
      ofType(developerActions.generatePublicKey),
      exhaustMap((action) =>
        this.developerService
          .generatePublicKey()
          .pipe(
            exhaustMap((response: any) => [
                developerActions.generatePublicKeySuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(developerActions.generatePublicKeyFailed())
            }
            )
          )
      )
    )
  );


}